import * as yup from 'yup'

export class CompanyClusterConversionCompanyDto {
  clusterConversionCompanyCode?: string = undefined
}

export const companyClusterConversionCompanyValidationSchema = yup.object<CompanyClusterConversionCompanyDto>({
  clusterConversionCompanyCode: yup
    .string()
    .min(3, 'Cluster Conversion Company Code must be 3 characters.')
    .max(3, 'Cluster Conversion Company Code must be 3 characters.')
    .required('Cluster Conversion Company Code is required.')
})
